import React, { useState, useContext, useEffect, useRef } from 'react';
import { AppContext, AuthContext } from 'Context';
import { useNavigate } from 'react-router-dom';
import './UserM.css';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { removeDummy, clearAllDummys, saveDummy, clearUploadDetails, saveUploadInfo, clearUploadInfo } from 'store/store';
import { CircularProgress as MuiCircularProgress, withStyles, IconButton, Dialog, DialogTitle, DialogContent, Menu, MenuItem } from '@material-ui/core';
import { baseUrl, firebaseCredentials, endpoints } from 'Api';
import { ReactComponent as HiddenIcon } from 'Assets/eye.slash.svg';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import EmailIcon from '@material-ui/icons/Email';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import GetAppIcon from '@material-ui/icons/GetApp';
import FilterListIcon from '@material-ui/icons/FilterList';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { ref, get, getDatabase, off, onValue, update } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import axios from 'axios';
import uploadManager from 'Utils/uploadManagerSecure';
import { InfoModal } from '../private/dashboard/info-modal/index';

function ManagerList({ isLoading, fetchMangerData, getToken, hiddenIndices, setHiddenIndices, userListData, setUserListData, showAll, clickLoading, setModal, isOpenModal, onLastAccessedCountChange }) {
  const dispatch = useDispatch();
  const { handleClick, setIamUploading, firebaseDatabase, setEncounterLoading, autoSignIn, setbigUserData, isTokenChange, iamUploading, getSubscription, setmessaged, setmangerFunctionData, setUploadContainer, setAppSnackbar, draftOfUpload, setActiveUploads, setUploadQueue, setOpen, handleCancelAllDownloads } = useContext(AppContext);
  const navigate = useNavigate();
  const tokens = getToken();
  const [isOpenInfoModal, setInfoModal] = useState(false);
  const [isOpenAllUsersModal, setIsOpenAllUsersModal] = useState(false);
  const [userObject, setUserObject] = useState();
  const [userIamChanging, setuserIamChanging] = useState(false);
  const [visibleEye, setVisibleEye] = useState(Array(userListData?.data?.length).fill(false));
  const [isInviting, setIsInviting] = useState(false);
  const [lastAccessedUsers, setLastAccessedUsers] = useState([]);
  const [isLoadingLastAccessed, setIsLoadingLastAccessed] = useState(true);
  const initialFirebaseSkipped = useRef(false);
  const [copyingUserId, setCopyingUserId] = useState(null);
  const [showHiddenUsers, setShowHiddenUsers] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [modalSearchQuery, setModalSearchQuery] = useState('');
  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const changeFieldFromFirebase = (draft_id, statusString) => {
    const dataToUpdate = {
      [draft_id]: {
        status: statusString,
      },
    };
    update(databaseRef, dataToUpdate);
  };
  const clearAllDummy = () => {
    dispatch(clearAllDummys());
  };
  const switchingFunction = async (obj) => {
    try {
      const formData = new FormData();
      formData.append('token', tokens);
      formData.append('user_id', obj.userId);
      formData.append('user_token', obj.token);
      const response = await axios.post(`${baseUrl}/managerUserLogs`, formData);
      if (response?.data?.success === true) {
        clearAllDummy();
        handleClick(obj);
        localStorage.setItem('firstname', obj?.firstname || '');
        localStorage.setItem('lastname', obj?.lastname || '');
        // Frontend marker for the impersonation session — the sidebar
        // "Accessed X's account" banner gates on this in addition to the
        // /getUserAccess response, so a normal login can't trip the banner.
        localStorage.setItem('isAccessingUser', 'true');
        localStorage.setItem('accessedUserId', String(obj?.userId || ''));
        navigate('/dashboard');
        getSubscription();
        autoSignIn();
      } else {
        setmessaged(response?.data?.message);
        setmangerFunctionData(true);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error); // Handle any errors
    }
  };
  const uploadPercentages = useSelector((state) => state.upload);
  const managerTokenFunction = async (obj) => {
    const uploadingOrNot = Object.values(uploadPercentages).some(
      (value) => typeof value === 'number' || value === 'Starting Upload'
    );
    if (!uploadingOrNot) {
      clearAllDummy();
      switchingFunction(obj);
    } else {
      setmessaged('You are uploading, so not able to access');
      setInfoModal(true);
    }
  };

  // Silent refresh - fetches data without showing loader
  const silentRefreshData = async () => {
    try {
      const apiUrl = `${baseUrl}/managerUsersList`;
      const requestBody = {
        token: tokens,
      };
      const response = await axios.post(apiUrl, requestBody);
      setUserListData(response.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching manager data:', error);
    }
  };

  const handleInviteUser = async (obj) => {
    // Optimistically update UI first - change icon to gray immediately
    setUserListData((prevData) => ({
      ...prevData,
      data: prevData.data.map((user) => (
        user.userId === obj.userId
          ? { ...user, signup_status: '2' }
          : user
      )),
    }));

    // Set inviting flag to prevent loader from showing
    setIsInviting(true);

    try {
      const response = await axios.post(`${baseUrl}/sendInviteLink`, {
        token: tokens,
        userId: obj.userId,
      });

      if (response?.data?.success) {
        setAppSnackbar({
          isVisible: true,
          message: response?.data?.message || 'Invitation sent successfully',
          type: 'success',
        });
        // Silently refresh data in background without showing loader
        await silentRefreshData();
      } else {
        // Revert the UI change if API failed
        setUserListData((prevData) => ({
          ...prevData,
          data: prevData.data.map((user) => (
            user.userId === obj.userId
              ? { ...user, signup_status: '0' }
              : user
          )),
        }));
        setAppSnackbar({
          isVisible: true,
          message: response?.data?.message || 'Failed to send invitation',
          type: 'error',
        });
      }
    } catch (error) {
      // Revert the UI change if API failed
      setUserListData((prevData) => ({
        ...prevData,
        data: prevData.data.map((user) => (
          user.userId === obj.userId
            ? { ...user, signup_status: '0' }
            : user
        )),
      }));
      // eslint-disable-next-line no-console
      console.error('Error inviting user:', error);
      setAppSnackbar({
        isVisible: true,
        message: error?.response?.data?.message || 'Failed to send invitation',
        type: 'error',
      });
    } finally {
      setIsInviting(false);
    }
  };
  // Fetch last 5 accessed users from new API
  const fetchLastAccessedUsers = async () => {
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/${endpoints.lastAccessedUsers}`;
      const requestBody = {
        token: myToken,
        limit: 5,
      };
      const response = await axios.post(apiUrl, requestBody);
      if (response?.data?.success && response?.data?.data) {
        setLastAccessedUsers(response.data.data);
        onLastAccessedCountChange?.(response.data.data.length);
      } else {
        setLastAccessedUsers([]);
        onLastAccessedCountChange?.(0);
      }
    } catch (error) {
      console.error('Error fetching last accessed users:', error);
      setLastAccessedUsers([]);
      onLastAccessedCountChange?.(0);
    } finally {
      setIsLoadingLastAccessed(false);
    }
  };

  const handleCopySignupLink = (obj) => {
    setCopyingUserId(obj.userId);

    const fetchLinkPromise = axios.post(`${baseUrl}${endpoints.copySignupLink}`, {
      token: tokens,
      userId: obj.userId,
    }).then((response) => {
      if (response?.data?.success && response?.data?.data?.short_url) {
        return response.data.data.short_url;
      }
      throw new Error(response?.data?.message || 'Failed to get signup link');
    });

    // Safari requires clipboard.write() to be called synchronously within a user gesture.
    // Passing a Promise to ClipboardItem satisfies this — Safari resolves it async but
    // retains the gesture context. Chrome/Firefox fall back to writeText() after await.
    if (typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
      const clipboardItem = new ClipboardItem({
        'text/plain': fetchLinkPromise.then((url) => new Blob([url], { type: 'text/plain' })),
      });
      navigator.clipboard.write([clipboardItem])
        .then(() => {
          setAppSnackbar({ isVisible: true, message: 'Signup link copied to clipboard', type: 'success' });
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error copying signup link:', error);
          setAppSnackbar({ isVisible: true, message: 'Failed to copy signup link', type: 'error' });
        })
        .finally(() => {
          setCopyingUserId(null);
        });
    } else {
      // Fallback for browsers without ClipboardItem support
      fetchLinkPromise
        .then((url) => navigator.clipboard.writeText(url))
        .then(() => {
          setAppSnackbar({ isVisible: true, message: 'Signup link copied to clipboard', type: 'success' });
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error copying signup link:', error);
          setAppSnackbar({ isVisible: true, message: error?.message || 'Failed to copy signup link', type: 'error' });
        })
        .finally(() => {
          setCopyingUserId(null);
        });
    }
  };
  useEffect(() => {
    fetchMangerData();
    fetchLastAccessedUsers();
  }, [isTokenChange]);

  useEffect(() => {
    const databaseRefManUsers = ref(firebaseDatabase, `manager_user_list_updates/${localStorage.getItem('id')}`);
    const dataCallbackMans = (snapshot) => {
      // Skip the first callback - onValue fires immediately with current data
      // and we already fetch in the other useEffect
      if (!initialFirebaseSkipped.current) {
        initialFirebaseSkipped.current = true;
        return;
      }
      if (snapshot.exists()) {
        fetchMangerData();
        fetchLastAccessedUsers();
      }
    };
    onValue(databaseRefManUsers, dataCallbackMans);
    return () => {
      off(databaseRefManUsers, 'value', dataCallbackMans);
    };
  }, []);

  // Sync parent modal state with local modal state
  useEffect(() => {
    if (isOpenModal !== undefined) {
      setIsOpenAllUsersModal(isOpenModal);
    }
  }, [isOpenModal]);

  // Refresh data when modal opens
  useEffect(() => {
    if (isOpenAllUsersModal) {
      fetchMangerData();
    }
  }, [isOpenAllUsersModal]);
  const updateDummy = (dummy, status) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };
  const handleUserData = (obj) => {
    // temp fix for production #TODO akash
    localStorage.setItem('temp_user_id', obj?.userId);
    // end temp fix
    setbigUserData(obj);
    navigate('/affiliate');
  };
  const closeToast = (draft_id, message, type) => {
    toast.update(draft_id, { closeButton: false, render: message, type: type === 'success' ? toast.TYPE.SUCCESS : toast.TYPE.ERROR, autoClose: 3000 });
    setUploadContainer((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
  };
  const updateUploadPercentages = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };
  const data = useSelector((state) => state.deleteUpload);
  const deleteAdded = (userObject) => {
    setOpen(false);
    setuserIamChanging(true);
    setEncounterLoading(true);

    // Cancel all active S3 uploads and null out callbacks to prevent registration APIs from firing
    if (uploadManager.uploads) {
      uploadManager.uploads.forEach((task) => {
        if (task && task.id) {
          // eslint-disable-next-line no-param-reassign
          task.updateUploadPercentages = null;
          // eslint-disable-next-line no-param-reassign
          task.suppressToast = true;
          // eslint-disable-next-line no-param-reassign
          task.onSuccess = null;
          // eslint-disable-next-line no-param-reassign
          task.onError = null;
          uploadManager.cancelUpload(task.id);
        }
      });
    }

    // Cancel all active cloud downloads
    if (handleCancelAllDownloads) {
      handleCancelAllDownloads();
    }

    const draftIds = Object.keys(uploadPercentages);
    const deletePromises = [];
    draftOfUpload.forEach((draftId) => {
      const uploadStatus = uploadPercentages[draftId];
      setActiveUploads([]);
      setUploadQueue([]);
      // Check if the uploadStatus is not "Please wait"
      if (uploadStatus !== 'Please wait') {
        // const deletePromise = axios
        //   .post(`${baseUrl}/deleteDraftContent`, {
        //     token: getToken(),
        //     draft_id: [draftId], // Pass the current draftId
        //     content_id: [],
        //   })
        //   .then((response) => {
        //     changeFieldFromFirebase(draftId, 'DELETED');
        //     updateDummy(draftId, 0);
        //     updateUploadPercentages(draftId, 'Cancelled');
        //     closeToast(draftId, 'Upload has been canceled by user', 'error');
        //     return response;
        //   })
        //   .catch((error) => {
        //     console.error(`Error deleting items for draftId ${draftId}:`, error);
        //     throw error;
        //   });
        // deletePromises.push(deletePromise);
        changeFieldFromFirebase(draftId, 'DELETED');
        updateDummy(draftId, 0);
        updateUploadPercentages(draftId, 'Cancelled');
        closeToast(draftId, 'Upload has been canceled by user', 'error');
        dispatch(clearUploadDetails());
      }
    });
    // Promise.all(deletePromises)
    //   .then(() => {
    //     setEncounterLoading(false);
    //     setInfoModal(false);
    //     setIamUploading(true);
    //     setuserIamChanging(false);
    //     switchingFunction(userObject);
    //   })
    //   .catch((error) => {
    //     console.error('Error deleting items:', error);
    //   });
    // Clear all upload state from Redux so stale entries don't block next access
    dispatch(clearUploadInfo());
    // Clear quickUploadVisited so next quick user creation can reach the upload page
    sessionStorage.removeItem('quickUploadVisited');
    sessionStorage.removeItem('quickUserEmail');
    setEncounterLoading(false);
    setInfoModal(false);
    setIamUploading(true);
    setuserIamChanging(false);
    switchingFunction(userObject);
  };
  const CircularProgress = withStyles({
    circle: {
      color: '#5aa5ef !important'
    }
  })(MuiCircularProgress);

  const toggleHidden = (index) => {
    if (hiddenIndices.includes(index)) {
      setHiddenIndices(hiddenIndices.filter((i) => i !== index));
    } else {
      setHiddenIndices([...hiddenIndices, index]);
    }
  };
  const hideManagerUser = (userId, index) => {
    const updatedVisibleEye = [...visibleEye];
    updatedVisibleEye[index] = true;
    setVisibleEye(updatedVisibleEye);
    const API_URL = `${baseUrl}/hideManagerUser`;
    const data = {
      token: getToken(),
      user_id: userId,
      hide: 1
    };
    axios.post(API_URL, data)
      .then((response) => {
        toggleHidden(userId);
        setAppSnackbar({ isVisible: true, message: response?.data?.message, type: 'error' });
        setVisibleEye((prevVisibleEye) => {
          const updatedVisibleEye = [...prevVisibleEye];
          updatedVisibleEye[index] = false;
          return updatedVisibleEye;
        });
        fetchLastAccessedUsers();
        fetchMangerData();
      })
      .catch((error) => {
        setAppSnackbar({ isVisible: true, type: 'error', message: error?.response?.message });
      });
  };

  const unhideManagerUser = (userId, index) => {
    const updatedVisibleEye = [...visibleEye];
    updatedVisibleEye[index] = true;
    setVisibleEye(updatedVisibleEye);
    const API_URL = `${baseUrl}/hideManagerUser`;
    const data = {
      token: getToken(),
      user_id: userId,
      hide: 0
    };
    axios.post(API_URL, data)
      .then((response) => {
        setAppSnackbar({ isVisible: true, message: response?.data?.message || 'User unhidden successfully', type: 'success' });
        setVisibleEye((prev) => {
          const updated = [...prev];
          updated[index] = false;
          return updated;
        });
        fetchMangerData();
        fetchLastAccessedUsers();
      })
      .catch((error) => {
        setVisibleEye((prev) => {
          const updated = [...prev];
          updated[index] = false;
          return updated;
        });
        setAppSnackbar({ isVisible: true, type: 'error', message: error?.response?.data?.message || 'Failed to unhide user' });
      });
  };

  // Function to re-hide users after modal closes (when showAll was called)
  const reHideUsers = () => {
    if (hiddenIndices && hiddenIndices.length > 0) {
      const API_URL = `${baseUrl}/hideManagerUser`;
      // Call hide API for each hidden user in parallel
      const hidePromises = hiddenIndices.map((userId) => axios.post(API_URL, {
        token: getToken(),
        user_id: userId
      }).catch(() => {
        // Silently handle errors for individual hide requests
      }));

      // After all hide requests complete, refresh data
      Promise.all(hidePromises).then(() => {
        if (fetchMangerData) {
          fetchMangerData();
        }
      });
    }
  };

  // All users from API
  const allUsersFromData = userListData?.data || [];

  // Use last accessed users from new API for the 5 users display (outside modal)
  const latest5Users = lastAccessedUsers;

  // For modal: show hidden or normal users based on toggle
  const reversedAllUsers = showHiddenUsers
    ? [...allUsersFromData.filter((obj) => obj?.visible === '0')].reverse()
    : [...allUsersFromData].reverse();

  // Filter modal users by search query - name matches first, then email matches
  const filteredModalUsers = (() => {
    if (!modalSearchQuery.trim()) return reversedAllUsers;
    const query = modalSearchQuery.toLowerCase();
    const nameMatches = [];
    const emailMatches = [];
    reversedAllUsers.forEach((user) => {
      const fullName = `${user?.firstname || ''} ${user?.lastname || ''}`.toLowerCase();
      const email = (user?.email || '').toLowerCase();
      if (fullName.includes(query)) {
        nameMatches.push(user);
      } else if (email.includes(query)) {
        emailMatches.push(user);
      }
    });
    return [...nameMatches, ...emailMatches];
  })();

  // Export users to CSV
  const exportUsersToCSV = () => {
    if (!allUsersFromData || allUsersFromData.length === 0) {
      toast.error('No users to export');
      return;
    }

    const headers = ['Name', 'Email', 'Plan', 'End Date', 'Last Accessed'];
    const csvRows = [headers.join(',')];

    allUsersFromData.forEach((user) => {
      const name = `${user?.firstname || ''} ${user?.lastname || ''}`.trim();
      const email = user?.email || '';
      // Match the table cell: no subscription → "Free"; otherwise
      // product_name + " (Expired)" suffix when expired:true.
      const planBase = user?.subscription?.product_name || 'Free';
      const plan = user?.subscription && user?.expired === true
        ? `${planBase} (Expired)`
        : planBase;
      const endDate = user?.subscription?.end_date
        ? new Date(user.subscription.end_date).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        })
        : '-';
      const lastAccessed = user?.last_accessed
        ? new Date(user.last_accessed).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        })
        : '';

      // Escape fields that might contain commas or quotes
      const escapedName = `"${name.replace(/"/g, '""')}"`;
      const escapedEmail = `"${email.replace(/"/g, '""')}"`;
      const escapedPlan = `"${plan.replace(/"/g, '""')}"`;
      const escapedEndDate = `"${endDate}"`;
      const escapedDate = `"${lastAccessed}"`;

      csvRows.push([escapedName, escapedEmail, escapedPlan, escapedEndDate, escapedDate].join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `users_list_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast.success('User list exported successfully');
  };

  // Render user row component
  const renderUserRow = (obj, index, isInModal = false) => (
    <div className={isInModal ? 'flexter w100' : 'flexter w100'} key={isInModal ? `modal-${obj?.userId}` : index} style={isInModal ? { marginBottom: '20px' } : {}}>
      <div className="rounder">{obj?.firstname?.charAt(0)?.toUpperCase()}</div>
      <div style={{ position: 'relative', flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '15px' }}>
          {(obj?.firstname || obj?.lastname) && (
            <p className="UserName" style={{ marginLeft: 0 }}>
              {obj?.firstname ? obj?.firstname?.charAt(0)?.toUpperCase() + obj?.firstname?.slice(1) : ''}
              {obj?.firstname && obj?.lastname ? ' ' : ''}
              {obj?.lastname ? obj?.lastname?.charAt(0)?.toUpperCase() + obj?.lastname?.slice(1) : ''}
            </p>
          )}
          {obj?.subscription?.plan_name && (
            <span style={{
              backgroundColor: obj?.subscription?.expired ? '#FEE2E2' : obj?.subscription?.plan_name === 'Free' ? '#FEE2E2' : '#E0F2FE',
              color: obj?.subscription?.expired ? '#DC2626' : obj?.subscription?.plan_name === 'Free' ? '#DC2626' : '#0369A1',
              fontSize: '11px',
              fontWeight: '700',
              padding: '3px 8px',
              borderRadius: '12px',
              border: `1.5px solid ${obj?.subscription?.expired ? '#EF4444' : obj?.subscription?.plan_name === 'Free' ? '#EF4444' : '#7DD3FC'}`,
              fontFamily: 'Montserrat',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              whiteSpace: 'nowrap'
            }}
            >
              {obj.subscription.expired ? 'Expired' : obj.subscription.plan_name === 'Free' ? 'Free Plan' : obj.subscription.plan_name}
            </span>
          )}
        </div>
        <p className="mySmallMail">
          {obj?.email}
        </p>
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        {/* Invite Button */}
        {(obj?.signup_status === '0' || obj?.signup_status === '2') ? (
          <>
            <IconButton
              onClick={() => handleInviteUser(obj)}
              style={{ padding: '6px', color: '#5aa5ef' }}
              title="Send invitation"
            >
              <EmailIcon style={{ fontSize: '20px' }} />
            </IconButton>
            <IconButton
              onClick={() => handleCopySignupLink(obj)}
              style={{ padding: '6px', color: '#5aa5ef' }}
              title="Copy signup link"
              disabled={copyingUserId === obj.userId}
            >
              {copyingUserId === obj.userId ? (
                <CircularProgress size={18} style={{ color: '#5aa5ef' }} />
              ) : (
                <FileCopyIcon style={{ fontSize: '18px' }} />
              )}
            </IconButton>
          </>
        ) : (
          <div style={{ width: '72px' }} />
        )}

        {/* Access Button */}
        <IconButton
          onClick={() => { setUserObject(obj); managerTokenFunction(obj); }}
          style={{ padding: '6px', color: '#5aa5ef' }}
          title="Access user account"
        >
          <ExitToAppIcon style={{ fontSize: '20px' }} />
        </IconButton>

        {!isInModal && (
          obj?.visible === '0' ? (
            <IconButton
              onClick={() => unhideManagerUser(obj?.userId, index)}
              style={{ padding: '6px', paddingRight: '0px', color: '#5aa5ef', opacity: visibleEye[index] ? 0.5 : 1, cursor: visibleEye[index] ? 'wait' : 'pointer' }}
              title="Unhide user"
            >
              <VisibilityIcon style={{ fontSize: '20px' }} />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => hideManagerUser(obj?.userId, index)}
              style={{ padding: '6px', paddingRight: '0px', color: '#5aa5ef', opacity: visibleEye[index] ? 0.5 : 1, cursor: visibleEye[index] ? 'wait' : 'pointer' }}
              title="Hide user"
            >
              <HiddenIcon style={{ width: '20px', height: '20px', fill: '#5aa5ef' }} />
            </IconButton>
          )
        )}
      </div>
    </div>
  );

  return (
    <div>
      {
        isOpenInfoModal && (
          <InfoModal
            isVisible={isOpenInfoModal}
            title="Uploading is in progress"
            onHide={() => { setInfoModal(false); }}
            continueButton="Continue with upload"
            userIamChanging={userIamChanging}
            actionButton="Access user anyway"
            action={() => deleteAdded(userObject)}
            isDelete
          />
        )
      }

      {/* All Users Modal */}
      <Dialog
        open={isOpenAllUsersModal}
        onClose={() => {
          setIsOpenAllUsersModal(false);
          if (setModal) setModal(false);
          setShowHiddenUsers(false);
          setFilterAnchorEl(null);
          setModalSearchQuery('');
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: '20px',
            height: '80vh',
            position: 'relative'
          }
        }}
      >
        {/* Close button - positioned absolutely at top right */}
        <DialogTitle style={{
          padding: '1.5rem 2rem',
          borderBottom: '1px solid #e5e7eb',
          background: '#f9fafb',
          margin: '-20px -20px 0 -20px'
        }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <span style={{
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: '700',
                fontSize: '1.5rem',
                color: '#111827',
                letterSpacing: '-0.02em'
              }}
              >
                View All Users
              </span>
              <input
                type="text"
                placeholder="Search by name or email..."
                value={modalSearchQuery}
                onChange={(e) => setModalSearchQuery(e.target.value)}
                style={{
                  padding: '0 20px',
                  border: '2px solid #5aa5ef',
                  borderRadius: '25px',
                  fontSize: '14px',
                  fontWeight: '500',
                  fontFamily: 'Montserrat, sans-serif',
                  outline: 'none',
                  width: '250px',
                  height: '42px',
                  background: '#ffffff',
                  color: '#1f2937',
                  transition: 'border-color 0.3s ease'
                }}
                onFocus={(e) => { e.target.style.borderColor = '#4a95df'; }}
                onBlur={(e) => { e.target.style.borderColor = '#5aa5ef'; }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  onClick={(e) => setFilterAnchorEl(e.currentTarget)}
                  style={{
                    padding: '4px',
                    color: '#5aa5ef',
                    transition: 'color 0.2s ease'
                  }}
                  title="Filter users"
                >
                  <FilterListIcon style={{ fontSize: '26px', strokeWidth: '1px', stroke: '#5aa5ef' }} />
                </IconButton>
                <Menu
                  anchorEl={filterAnchorEl}
                  open={Boolean(filterAnchorEl)}
                  onClose={() => setFilterAnchorEl(null)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                  getContentAnchorEl={null}
                  PaperProps={{ style: { marginTop: '4px', borderRadius: '8px' } }}
                >
                  <MenuItem
                    onClick={() => { setShowHiddenUsers(false); setFilterAnchorEl(null); }}
                    style={{
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: '14px',
                      fontWeight: !showHiddenUsers ? '600' : '400',
                      color: !showHiddenUsers ? '#5aa5ef' : '#374151',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <span style={{ width: '16px', height: '16px', borderRadius: '50%', border: '2px solid #5aa5ef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {!showHiddenUsers && <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#5aa5ef' }} />}
                    </span>
                    All users
                  </MenuItem>
                  <MenuItem
                    onClick={() => { setShowHiddenUsers(true); setFilterAnchorEl(null); }}
                    style={{
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: '14px',
                      fontWeight: showHiddenUsers ? '600' : '400',
                      color: showHiddenUsers ? '#5aa5ef' : '#374151',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <span style={{ width: '16px', height: '16px', borderRadius: '50%', border: '2px solid #5aa5ef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {showHiddenUsers && <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#5aa5ef' }} />}
                    </span>
                    Hidden users
                  </MenuItem>
                </Menu>
              </div>
            <button
              onClick={exportUsersToCSV}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '8px 16px',
                backgroundColor: '#5aa5ef',
                color: '#ffffff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                fontFamily: 'Montserrat, sans-serif',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => { e.target.style.backgroundColor = '#4a95df'; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = '#5aa5ef'; }}
            >
              <GetAppIcon style={{ fontSize: '18px' }} />
              Export
            </button>
              <button
                onClick={() => {
                  setIsOpenAllUsersModal(false);
                  if (setModal) setModal(false);
                  setShowHiddenUsers(false);
                  setModalSearchQuery('');
                }}
                style={{
                  background: '#f3f4f6',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#6b7280',
                  padding: '0.5rem',
                  lineHeight: '1',
                  borderRadius: '0.5rem',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => { e.target.style.background = '#e5e7eb'; }}
                onMouseLeave={(e) => { e.target.style.background = '#f3f4f6'; }}
              >
                ×
              </button>
            </div>
          </div>
        </DialogTitle>

        <DialogContent style={{ padding: '20px' }}>
          {/* Show All button - commented out as per requirement */}
          {/* {(hiddenIndices?.length > 0 || userListData?.show_all) && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
              <button
                className="unhidePls"
                onClick={() => showAll && showAll()}
                disabled={clickLoading}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: 0,
                  marginTop: 0
                }}
              >
                {clickLoading ? <CircularProgress size={16} style={{ color: '#000000' }} /> : 'Show All'}
              </button>
            </div>
          )} */}

          {/* Table Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '14px 20px',
            gap: '20px',
            borderBottom: '2px solid #e5e7eb',
            backgroundColor: '#f9fafb',
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: '600',
            fontSize: '13px',
            color: '#374151',
            borderRadius: '8px 8px 0 0'
          }}
          >
            <span style={{ flex: 1, minWidth: '0' }}>Name</span>
            <span style={{ flex: 1, minWidth: '0', textAlign: 'center' }}>Email</span>
            <span style={{ width: '160px', minWidth: '160px', textAlign: 'center' }}>Plan</span>
            <span style={{ width: '100px', textAlign: 'left', paddingLeft: '10px' }}>Accessed on</span>
            <span style={{ width: '120px', minWidth: '120px', textAlign: 'center' }}>Actions</span>
          </div>

          {/* Table Body - Show ALL users including hidden ones */}
          <div style={{ maxHeight: '55vh', overflow: 'auto' }}>
            {filteredModalUsers.length === 0 && modalSearchQuery.trim() ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '60px 20px',
                color: '#9ca3af'
              }}
              >
                <span style={{ fontSize: '48px', marginBottom: '16px' }}>&#128269;</span>
                <p style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#6b7280',
                  margin: '0 0 8px 0'
                }}
                >
                  No users found
                </p>
                <p style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#9ca3af',
                  margin: 0
                }}
                >
                  {`No results for "${modalSearchQuery}"`}
                </p>
              </div>
            ) : filteredModalUsers.map((obj, index) => (
              <div
                key={obj?.userId}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '14px 20px',
                  borderBottom: '1px solid #f3f4f6',
                  transition: 'all 0.2s ease',
                  gap: '20px',
                  fontFamily: 'Montserrat, sans-serif'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#f9fafb'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
              >
                {/* User Info */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flex: 1, minWidth: '0' }}>
                  <div style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #5aa5ef 0%, #4a95df 100%)',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '600',
                    fontSize: '16px',
                    flexShrink: '0',
                    boxShadow: '0 2px 6px rgba(90, 165, 239, 0.2)',
                    border: '2px solid #fff'
                  }}
                  >
                    {obj?.firstname?.charAt(0)?.toUpperCase()}
                  </div>
                  <div style={{ minWidth: '0', flex: '1' }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                    >
                      {(obj?.firstname || obj?.lastname) && (
                        <span style={{
                          fontWeight: '600',
                          color: '#1f2937',
                          fontSize: '14px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          lineHeight: '1.4',
                          letterSpacing: '-0.01em'
                        }}
                        >
                          {obj?.firstname ? obj?.firstname?.charAt(0)?.toUpperCase() + obj?.firstname?.slice(1) : ''}
                          {obj?.firstname && obj?.lastname ? ' ' : ''}
                          {obj?.lastname ? obj?.lastname?.charAt(0)?.toUpperCase() + obj?.lastname?.slice(1) : ''}
                        </span>
                      )}
                      {obj?.subscription?.plan_name && (
                        <span style={{
                          backgroundColor: obj?.subscription?.expired ? '#FEE2E2' : obj?.subscription?.plan_name === 'Free' ? '#FEE2E2' : '#E0F2FE',
                          color: obj?.subscription?.expired ? '#DC2626' : obj?.subscription?.plan_name === 'Free' ? '#DC2626' : '#0369A1',
                          fontSize: '11px',
                          fontWeight: '700',
                          padding: '3px 8px',
                          borderRadius: '12px',
                          border: `1.5px solid ${obj?.subscription?.expired ? '#EF4444' : obj?.subscription?.plan_name === 'Free' ? '#EF4444' : '#7DD3FC'}`,
                          fontFamily: 'Montserrat',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          whiteSpace: 'nowrap'
                        }}
                        >
                          {obj.subscription.expired ? 'Expired' : obj.subscription.plan_name === 'Free' ? 'Free Plan' : obj.subscription.plan_name}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div style={{
                  color: '#6b7280',
                  fontSize: '13px',
                  flex: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: '500',
                  minWidth: '0',
                  textAlign: 'center'
                }}
                >
                  {obj?.email}
                </div>

                {/* Plan — "Free" when no subscription; product_name
                    otherwise. End date sits on its own line in smaller
                    text below: red when expired, gray when active. Free
                    users get no second line. */}
                <div style={{
                  width: '160px',
                  minWidth: '160px',
                  textAlign: 'center',
                  color: '#6b7280',
                  fontSize: '13px',
                  fontWeight: '500',
                  lineHeight: 1.25,
                }}
                >
                  <div style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  >
                    {obj?.subscription?.product_name || 'Free'}
                  </div>
                  {obj?.subscription?.end_date && (
                    <div style={{
                      color: obj?.expired === true ? '#dc2626' : '#9ca3af',
                      fontWeight: 600,
                      fontSize: '11px',
                    }}
                    >
                      {new Date(obj.subscription.end_date).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                      })}
                    </div>
                  )}
                </div>

                {/* Accessed on */}
                <div style={{ width: '100px', textAlign: 'left', paddingLeft: '10px' }}>
                  {obj?.last_accessed && (
                    <span style={{
                      color: '#6b7280',
                      fontSize: '13px',
                      fontWeight: '500',
                      whiteSpace: 'nowrap'
                    }}
                    >
                      {new Date(obj.last_accessed).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}
                    </span>
                  )}
                </div>

                {/* Actions */}
                <div style={{ width: '120px', minWidth: '120px', display: 'flex', justifyContent: 'center', gap: '4px', alignItems: 'center' }}>
                  {(obj?.signup_status === '0' || obj?.signup_status === '2') ? (
                    <>
                      <IconButton
                        onClick={() => handleInviteUser(obj)}
                        style={{ padding: '6px', color: '#5aa5ef' }}
                        title="Send invitation"
                      >
                        <EmailIcon style={{ fontSize: '20px' }} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleCopySignupLink(obj)}
                        style={{ padding: '6px', color: '#5aa5ef' }}
                        title="Copy signup link"
                        disabled={copyingUserId === obj.userId}
                      >
                        {copyingUserId === obj.userId ? (
                          <CircularProgress size={18} style={{ color: '#5aa5ef' }} />
                        ) : (
                          <FileCopyIcon style={{ fontSize: '18px' }} />
                        )}
                      </IconButton>
                    </>
                  ) : (
                    <div style={{ width: '72px' }} />
                  )}
                  <IconButton
                    onClick={() => { setUserObject(obj); managerTokenFunction(obj); setIsOpenAllUsersModal(false); }}
                    style={{ padding: '6px', color: '#5aa5ef' }}
                    title="Access user account"
                  >
                    <ExitToAppIcon style={{ fontSize: '20px' }} />
                  </IconButton>
                  {obj?.visible === '0' ? (
                    <IconButton
                      onClick={() => unhideManagerUser(obj?.userId, index)}
                      style={{ padding: '0px', margin: '0px', color: '#5aa5ef', opacity: visibleEye[index] ? 0.5 : 1, cursor: visibleEye[index] ? 'wait' : 'pointer' }}
                      title="Unhide user"
                    >
                      <VisibilityIcon style={{ fontSize: '20px' }} />
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={() => hideManagerUser(obj?.userId, index)}
                      style={{ padding: '0px', margin: '0px', color: '#5aa5ef', opacity: visibleEye[index] ? 0.5 : 1, cursor: visibleEye[index] ? 'wait' : 'pointer' }}
                      title="Hide user"
                    >
                      <HiddenIcon style={{ width: '20px', height: '20px', fill: '#5aa5ef' }} />
                    </IconButton>
                  )}
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>

      <div className="the_Hieghter" style={{ paddingRight: 0 }}>
        {isLoadingLastAccessed && !isInviting ? (
          <div style={{ display: 'flex' }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            {latest5Users.map((obj, i) => renderUserRow(obj, i, false))}
          </>
        )}
      </div>
    </div>

  );
}

export default ManagerList;
